import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "agreement"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-12 text-center" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-12 text-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "mb-5" }
const _hoisted_19 = { style: {"line-height":"29px"} }
const _hoisted_20 = { class: "switch" }
const _hoisted_21 = ["checked"]
const _hoisted_22 = {
  key: 0,
  class: "billing-address-block"
}
const _hoisted_23 = { class: "row mb-4" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "row mb-4" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { class: "row mb-4" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "row mb-4" }
const _hoisted_30 = { class: "col-sm-12 col-md-6" }
const _hoisted_31 = { class: "col-sm-12 col-md-6" }
const _hoisted_32 = { class: "row mb-4" }
const _hoisted_33 = { class: "col-sm-12 col-md-5" }
const _hoisted_34 = { class: "col-sm-12 col-md-3" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "col-sm-12 col-md-4" }
const _hoisted_37 = { class: "row mb-4" }
const _hoisted_38 = { class: "offset-3 col-6" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-6" }
const _hoisted_41 = { class: "col-6" }
const _hoisted_42 = { class: "row mb-4" }
const _hoisted_43 = { class: "col-12" }
const _hoisted_44 = { class: "row mb-4" }
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { class: "card" }
const _hoisted_50 = { class: "card-body" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = {
  key: 0,
  class: "row"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = ["v-if"]
const _hoisted_56 = ["v-if"]
const _hoisted_57 = { class: "col-12" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = {
  key: 0,
  class: "row mt-5"
}
const _hoisted_61 = { class: "col-12" }
const _hoisted_62 = { class: "alert alert-danger" }
const _hoisted_63 = { class: "row" }
const _hoisted_64 = { class: "col-12" }
const _hoisted_65 = { class: "col-6" }
const _hoisted_66 = { key: 2 }
const _hoisted_67 = { class: "card" }
const _hoisted_68 = { class: "card-body" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-12" }
const _hoisted_71 = ["href"]
const _hoisted_72 = { class: "mb-5" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "mb-0" }
const _hoisted_75 = { class: "text-center" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_StripeElement = _resolveComponent("StripeElement")!
  const _component_StripeElements = _resolveComponent("StripeElements")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && _ctx.agreement)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.agreement.is_rejected)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[17] || (_cache[17] = [
                _createElementVNode("h2", { class: "mb-0" }, "Agreement Rejected", -1),
                _createElementVNode("p", null, "Your requested quote has been rejected", -1)
              ])))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (!_ctx.agreement.is_agreement_signed || _ctx.view_agreement)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "mb-0" }, "Simclusive Services Agreement", -1)),
                          _createElementVNode("p", null, [
                            _createElementVNode("small", null, [
                              _cache[18] || (_cache[18] = _createTextVNode("You ")),
                              (_ctx.view_agreement)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "have agreed"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_8, "are required to agree")),
                              _cache[19] || (_cache[19] = _createTextVNode(" to the following terms and conditions to license a co-brand."))
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.view_agreement)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewAgreement && _ctx.viewAgreement(...args)))
                              }, "View Receipt")
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("iframe", {
                            src: _ctx.pdf_path,
                            width: "70%",
                            height: "800"
                          }, null, 8, _hoisted_13)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                          (_ctx.agreement.is_agreement_signed)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_16, "You agreed to this document on " + _toDisplayString(_ctx.moment(_ctx.agreement.agreement_signed_at).format('MM/DD/YYYY')) + ".", 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("p", _hoisted_19, [
                                    _cache[22] || (_cache[22] = _createTextVNode("Do you need a separate billing contact? ")),
                                    _createElementVNode("label", _hoisted_20, [
                                      _createElementVNode("input", {
                                        id: "billing_address_checkbox",
                                        type: "checkbox",
                                        checked: _ctx.billing_address,
                                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleBillingAddress && _ctx.toggleBillingAddress(...args)))
                                      }, null, 40, _hoisted_21),
                                      _cache[21] || (_cache[21] = _createElementVNode("span", { class: "slider round" }, null, -1))
                                    ])
                                  ]),
                                  (_ctx.billing_address)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("div", _hoisted_24, [
                                            _cache[23] || (_cache[23] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_name"
                                            }, [
                                              _createTextVNode("Name "),
                                              _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              class: "w-100",
                                              type: "text",
                                              maxlength: "255",
                                              name: "billing_name",
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.billing_name) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.billing_name]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("div", _hoisted_26, [
                                            _cache[24] || (_cache[24] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_email"
                                            }, [
                                              _createTextVNode("Email "),
                                              _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              class: "w-100",
                                              type: "email",
                                              maxlength: "255",
                                              name: "billing_email",
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.billing_email) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.billing_email]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_27, [
                                          _createElementVNode("div", _hoisted_28, [
                                            _cache[25] || (_cache[25] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_phone"
                                            }, [
                                              _createTextVNode("Phone "),
                                              _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _createVNode(_component_vue_tel_input, {
                                              "v-model": _ctx.billing_phone,
                                              value: _ctx.billing_phone,
                                              mode: "international",
                                              "preferred-countries": ['US','CA','MX'],
                                              onValidate: _ctx.setBillingPhone
                                            }, null, 8, ["v-model", "value", "onValidate"])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("div", _hoisted_30, [
                                            _cache[26] || (_cache[26] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_address_1"
                                            }, [
                                              _createTextVNode("Address 1 "),
                                              _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              class: "w-100",
                                              type: "text",
                                              maxlength: "255",
                                              name: "billing_address_1",
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.billing_address_1) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.billing_address_1]
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_31, [
                                            _cache[27] || (_cache[27] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_address_2"
                                            }, "Address 2", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              class: "w-100",
                                              type: "text",
                                              maxlength: "255",
                                              name: "billing_address_2",
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.billing_address_2) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.billing_address_2]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("div", _hoisted_33, [
                                            _cache[28] || (_cache[28] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_city"
                                            }, [
                                              _createTextVNode("City "),
                                              _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              class: "w-100",
                                              type: "text",
                                              maxlength: "255",
                                              name: "billing_city",
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.billing_city) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.billing_city]
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_34, [
                                            _cache[29] || (_cache[29] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_state"
                                            }, [
                                              _createTextVNode("State "),
                                              _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _withDirectives(_createElementVNode("select", {
                                              class: "w-100",
                                              name: "billing_state",
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.billing_state) = $event))
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: state.id,
                                                  value: state.short_name
                                                }, _toDisplayString(state.short_name), 9, _hoisted_35))
                                              }), 128))
                                            ], 512), [
                                              [_vModelSelect, _ctx.billing_state]
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_36, [
                                            _cache[30] || (_cache[30] = _createElementVNode("label", {
                                              class: "d-block",
                                              for: "billing_zip"
                                            }, [
                                              _createTextVNode("Zip Code "),
                                              _createElementVNode("span", { class: "text-danger" }, "*")
                                            ], -1)),
                                            _withDirectives(_createElementVNode("input", {
                                              class: "w-100",
                                              type: "text",
                                              maxlength: "25",
                                              name: "billing_zip",
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.billing_zip) = $event))
                                            }, null, 512), [
                                              [_vModelText, _ctx.billing_zip]
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[37] || (_cache[37] = _createElementVNode("p", null, [
                                  _createTextVNode("By entering your name in the boxes below,"),
                                  _createElementVNode("br"),
                                  _createTextVNode("you acknowledge that you agree to the terms in the document above.")
                                ], -1)),
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                      _createElementVNode("div", _hoisted_40, [
                                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text-center" }, [
                                          _createElementVNode("label", { for: "first_name" }, "First Name")
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          name: "first_name",
                                          type: "text",
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.first_name) = $event))
                                        }, null, 512), [
                                          [_vModelText, _ctx.first_name]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_41, [
                                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "text-center" }, [
                                          _createElementVNode("label", { for: "last_name" }, "Last Name")
                                        ], -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          name: "last_name",
                                          type: "text",
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.last_name) = $event))
                                        }, null, 512), [
                                          [_vModelText, _ctx.last_name]
                                        ])
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("button", {
                                      class: "btn btn-primary",
                                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.agreeToTerms && _ctx.agreeToTerms(...args)))
                                    }, "I agree to the terms above")
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("p", null, [
                                      _cache[33] || (_cache[33] = _createTextVNode("On the next page, you will be able to pay via a Credit Card")),
                                      _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                                      _cache[35] || (_cache[35] = _createTextVNode(" in the amount of ")),
                                      _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.agreement.total_amount) + " USD", 1),
                                      _cache[36] || (_cache[36] = _createTextVNode(" to finalize the agreement."))
                                    ])
                                  ])
                                ])
                              ]))
                        ])
                      ])
                    ]))
                  : (!_ctx.agreement.is_payment_made)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "row" }, null, -1)),
                                    _cache[44] || (_cache[44] = _createElementVNode("h2", { class: "mb-0" }, "Credit Card Payment", -1)),
                                    _createElementVNode("p", null, [
                                      _createElementVNode("small", null, [
                                        _cache[39] || (_cache[39] = _createTextVNode("You are requested to pay ")),
                                        _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.agreement.total_amount) + " USD", 1),
                                        _cache[40] || (_cache[40] = _createTextVNode(" to finalize the agreement"))
                                      ])
                                    ]),
                                    (_ctx.agreement.invoice_requested)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, _cache[41] || (_cache[41] = [
                                          _createElementVNode("div", { class: "col-12" }, [
                                            _createElementVNode("p", null, [
                                              _createTextVNode("You requested an invoice. You will be notified by email once the invoice is available. If you require additional assistance, please contact "),
                                              _createElementVNode("a", { href: "mailto:simclusive@sp-ed.com" }, "support@simclusive.com"),
                                              _createTextVNode(". Note that your partner URL/name will not be available until payment has been submitted.")
                                            ])
                                          ], -1)
                                        ])))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                          _createElementVNode("div", {
                                            class: "row",
                                            "v-if": _ctx.stripe_loaded
                                          }, _cache[42] || (_cache[42] = [
                                            _createElementVNode("div", { class: "col-12" }, [
                                              _createElementVNode("label", { for: "name_on_card" }, "Name as it appears on card")
                                            ], -1)
                                          ]), 8, _hoisted_55),
                                          _createElementVNode("div", {
                                            class: "row",
                                            "v-if": _ctx.stripe_loaded
                                          }, [
                                            _createElementVNode("div", _hoisted_57, [
                                              _withDirectives(_createElementVNode("input", {
                                                class: "mb-4",
                                                type: "text",
                                                maxlength: "100",
                                                name: "name_on_card",
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.name_on_card) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.name_on_card]
                                              ])
                                            ])
                                          ], 8, _hoisted_56),
                                          _createElementVNode("div", _hoisted_58, [
                                            _createElementVNode("div", _hoisted_59, [
                                              (_ctx.stripe_loaded)
                                                ? (_openBlock(), _createBlock(_component_StripeElements, {
                                                    key: 0,
                                                    type: "payment",
                                                    ref: "elms",
                                                    "stripe-key": _ctx.stripe_key,
                                                    "instance-options": _ctx.instance_options,
                                                    "elements-options": _ctx.elements_options
                                                  }, {
                                                    default: _withCtx(({ elements, instance }) => [
                                                      _createVNode(_component_StripeElement, {
                                                        ref: "card",
                                                        elements: elements,
                                                        options: _ctx.card_options,
                                                        instance: instance
                                                      }, null, 8, ["elements", "options", "instance"])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["stripe-key", "instance-options", "elements-options"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          (_ctx.has_card_error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                _createElementVNode("div", _hoisted_61, [
                                                  _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.card_error), 1)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("div", _hoisted_63, [
                                            _createElementVNode("div", _hoisted_64, [
                                              (_ctx.stripe_loaded)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: "btn btn-primary mt-5",
                                                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)))
                                                  }, "Submit Payment"))
                                                : _createCommentVNode("", true)
                                            ])
                                          ])
                                        ]))
                                  ]),
                                  _createElementVNode("div", _hoisted_65, [
                                    _cache[45] || (_cache[45] = _createElementVNode("h2", { class: "mb-0" }, "Invoice Payment", -1)),
                                    _cache[46] || (_cache[46] = _createElementVNode("p", null, "Would you like to request an invoice instead?", -1)),
                                    _createElementVNode("button", {
                                      class: "btn btn-primary",
                                      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.requestInvoice && _ctx.requestInvoice(...args)))
                                    }, "Request Invoice")
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "row" }, [
                          _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("h2", null, "Agreement Finalized")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("div", _hoisted_70, [
                                _cache[52] || (_cache[52] = _createElementVNode("h3", { class: "mb-0" }, "Thank you", -1)),
                                _cache[53] || (_cache[53] = _createElementVNode("h4", { class: "pt-0 pb-4" }, "Welcome to Simclusive", -1)),
                                _createElementVNode("h3", null, _toDisplayString(_ctx.store.getters.user.props.company_name), 1),
                                _createElementVNode("p", null, [
                                  _createElementVNode("small", null, [
                                    _createElementVNode("a", {
                                      href: _ctx.partner_url,
                                      target: "_blank"
                                    }, _toDisplayString(_ctx.partner_url), 9, _hoisted_71)
                                  ])
                                ]),
                                _createElementVNode("p", null, [
                                  _cache[47] || (_cache[47] = _createElementVNode("strong", null, "Payment:", -1)),
                                  _createTextVNode(" $" + _toDisplayString(_ctx.agreement.total_amount) + " on " + _toDisplayString(_ctx.moment(_ctx.agreement['payment_made_at']).format('MM/DD/YYYY')), 1)
                                ]),
                                _createElementVNode("p", null, [
                                  _cache[48] || (_cache[48] = _createElementVNode("strong", null, "Number of Sessions:", -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.agreement['number_of_sessions']), 1)
                                ]),
                                _cache[54] || (_cache[54] = _createElementVNode("p", null, [
                                  _createElementVNode("strong", null, "Scenarios")
                                ], -1)),
                                _createElementVNode("ul", _hoisted_72, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (scenario) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: scenario.id,
                                      class: "mb-2"
                                    }, _toDisplayString(scenario.patient_name), 1))
                                  }), 128))
                                ]),
                                _createElementVNode("button", {
                                  class: "btn btn-primary mb-4",
                                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.viewAgreement && _ctx.viewAgreement(...args)))
                                }, "View Agreement"),
                                _createElementVNode("p", null, "Agreement signed " + _toDisplayString(_ctx.moment(_ctx.agreement['agreement_signed_at']).format('MM/DD/YYYY')), 1),
                                (_ctx.password != '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                      _createElementVNode("p", _hoisted_74, [
                                        _cache[49] || (_cache[49] = _createElementVNode("strong", null, "Passcode: ", -1)),
                                        _createTextVNode(_toDisplayString(_ctx.password), 1)
                                      ]),
                                      _cache[50] || (_cache[50] = _createElementVNode("p", null, [
                                        _createElementVNode("small", null, "In order to sign up for sessions, participants will be required to enter above passcode.")
                                      ], -1))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_75, [
                                  _cache[51] || (_cache[51] = _createElementVNode("h2", null, [
                                    _createElementVNode("strong", null, "NEXT STEP:")
                                  ], -1)),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary",
                                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.configureLandingPage && _ctx.configureLandingPage(...args)))
                                  }, "Configure Your Landing Page")
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
              ]))
        ]))
      : (_ctx.err_msg != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"]),
    _createVNode(_component_loading, {
      active: _ctx.card_loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}